import React from 'react';
import coverbackground from '../../assets/near-space.jpg';
import ReusableScrollCard from '../../components/ReusableScrollcard/ReusableScrollcard';

class ScrollNearspace extends React.Component {
  render () { 
   return(
  
  <ReusableScrollCard             
    
        tag="EXPLORE"
        description="Near Space"
        coverbackground={coverbackground}
     />
  
  );
 }
}   

export default ScrollNearspace;